export default function MessageIcon({
  color = '#878F9B',
  width = '20',
  height = '20',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.9173 9.375H7.08398C6.74232 9.375 6.45898 9.09167 6.45898 8.75C6.45898 8.40833 6.74232 8.125 7.08398 8.125H12.9173C13.259 8.125 13.5423 8.40833 13.5423 8.75C13.5423 9.09167 13.259 9.375 12.9173 9.375Z'
        fill={color}
      />
      <path
        d='M13.3327 18.5998C13.0493 18.5998 12.766 18.5166 12.5243 18.3583L8.97435 15.9915H5.83268C2.96602 15.9915 1.04102 14.0665 1.04102 11.1998V6.19987C1.04102 3.3332 2.96602 1.4082 5.83268 1.4082H14.166C17.0327 1.4082 18.9577 3.3332 18.9577 6.19987V11.1998C18.9577 13.8498 17.3077 15.6999 14.791 15.9583V17.1415C14.791 17.6832 14.4993 18.1748 14.0243 18.4248C13.8077 18.5415 13.566 18.5998 13.3327 18.5998ZM5.83268 2.64986C3.68268 2.64986 2.29102 4.04153 2.29102 6.19153V11.1915C2.29102 13.3415 3.68268 14.7332 5.83268 14.7332H9.16602C9.29102 14.7332 9.40768 14.7665 9.51602 14.8415L13.2243 17.3083C13.316 17.3666 13.3993 17.3416 13.441 17.3166C13.4827 17.2916 13.5493 17.2415 13.5493 17.1332V15.3582C13.5493 15.0165 13.8327 14.7332 14.1743 14.7332C16.3243 14.7332 17.716 13.3415 17.716 11.1915V6.19153C17.716 4.04153 16.3243 2.64986 14.1743 2.64986H5.83268Z'
        fill={color}
      />
    </svg>
  );
}
